export default "__VITE_ASSET__BR8wNzg8__"